import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { WatchlistService } from '../../../../shared/services/watchlist.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-action-buttons',
  standalone: false,
  templateUrl: './action-buttons.component.html',
  styleUrl: './action-buttons.component.scss'
})
export class ActionButtonsComponent implements OnInit, OnDestroy {
  isAuthDropdownOpen = false;
  watchlistCount = 0;
  currentUser: any = null;
  private subscription = new Subscription();

  constructor(
    private watchlistService: WatchlistService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Only subscribe to watchlist if user is logged in
    this.subscription.add(
      this.authService.currentUser$.subscribe(user => {
        this.currentUser = user;
        if (user) {
          // User is logged in, subscribe to watchlist
          this.subscription.add(
            this.watchlistService.watchlist$.subscribe(items => {
              this.watchlistCount = items.length;
            })
          );
        } else {
          // User is not logged in, reset count
          this.watchlistCount = 0;
        }
      })
    );
  }

  getInitials(): string {
    if (!this.currentUser) return '';
    const firstName = this.currentUser.firstName || '';
    const lastName = this.currentUser.lastName || '';
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    return firstName.charAt(0).toUpperCase() || this.currentUser.email?.charAt(0).toUpperCase() || 'U';
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  toggleAuthDropdown(): void {
    this.isAuthDropdownOpen = !this.isAuthDropdownOpen;
  }

  @HostListener('window:scroll', ['$event'])
  @HostListener('document:scroll', ['$event'])
  onWindowScroll() {
    if (this.isAuthDropdownOpen) {
      this.isAuthDropdownOpen = false;
    }
  }

  closeAuthDropdown(): void {
    this.isAuthDropdownOpen = false;
  }
}
